const FAVICON_LIGHT = '/favicon-light.png';
const FAVICON_DARK = '/favicon-dark.png';
const FAVICON_LINK_ID = 'gamut-favicon';

export function resolveSystemFaviconHref(): string {
  return window.matchMedia('(prefers-color-scheme: dark)').matches
    ? FAVICON_DARK
    : FAVICON_LIGHT;
}

/** Keep favicon in sync with OS color scheme only (ignores in-app theme). */
export function applySystemFavicon(): void {
  const href = resolveSystemFaviconHref();

  document.querySelectorAll('link[rel="icon"]').forEach((node) => {
    if (node.id !== FAVICON_LINK_ID) {
      node.remove();
    }
  });

  let link = document.getElementById(FAVICON_LINK_ID) as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement('link');
    link.id = FAVICON_LINK_ID;
    link.rel = 'icon';
    link.type = 'image/png';
    document.head.appendChild(link);
  }

  const absoluteHref = new URL(href, window.location.origin).href;
  if (link.href !== absoluteHref) {
    link.href = href;
  }
}
